import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../constants';
import { FormattedMessage } from 'react-intl';

const COOKIE_NAME = 'cookieConsent';

const setCookie = (name: string, value: string, days: number) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value}${expires}; path=/`;
};

const getCookie = (name: string): string | null => {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    cookie = cookie.trim();
    if (cookie.startsWith(nameEQ)) return cookie.substring(nameEQ.length);
  }
  return null;
};

export const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    if (!getCookie(COOKIE_NAME)) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setCookie(COOKIE_NAME, 'accepted', 365);
    setIsVisible(false);
  };

  const handleDecline = () => {
    setCookie(COOKIE_NAME, 'declined', 365);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className='fixed bottom-4 left-4 right-4 md:max-w-md md:left-auto md:right-4 bg-white text-gray-800 p-4 rounded-lg shadow-md z-50 flex flex-col gap-3'>
      <p className='text-sm'>
        <FormattedMessage
          id='cookie.weUseCookie'
          defaultMessage='Мы используем куки, чтобы улучшить ваш опыт.'
        />{' '}
        <Link
          to={ROUTES.privacy}
          className='text-blue-600 hover:text-blue-700 transition-colors'
        >
          <FormattedMessage id='cookie.more' defaultMessage='Подробнее' />
        </Link>
      </p>
      <div className='flex gap-3 justify-end'>
        {/*<button*/}
        {/*  onClick={handleDecline}*/}
        {/*  className='bg-gray-200 hover:bg-gray-300 text-gray-800 px-3 py-1.5 rounded-lg text-sm transition-colors'*/}
        {/*>*/}
        {/*  <FormattedMessage id='cookie.decline' defaultMessage='Отклонить' />*/}
        {/*</button>*/}
        <button
          onClick={handleAccept}
          className='bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded-lg text-sm transition-colors'
        >
          <FormattedMessage id='cookie.accept' defaultMessage='Принять' />
        </button>
      </div>
    </div>
  );
};
